import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';

const Login = () => {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(phone, password);
      navigate('/app');
    } catch (err) {
      setError(err.response?.data?.message || 'Ошибка входа. Проверьте данные.');
    } finally {
      setLoading(false);
    }
  };

  const handleDemoLogin = async () => {
    setPhone('+79999999999');
    setPassword('demo123');
    setLoading(true);
    try {
      await login('+79999999999', 'demo123');
      navigate('/app');
    } catch (err) {
      setError('Ошибка демо-входа');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1>FITHOUSSE</h1>
          <p>Твоя сила. Твои правила. Твой результат.</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <h2>Вход</h2>

          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label>Номер телефона</label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="+7 (999) 999-99-99"
              required
            />
          </div>

          <div className="form-group">
            <label>Пароль</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Введите пароль"
              required
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Загрузка...' : 'Войти'}
          </button>

          <button type="button" className="btn-demo" onClick={handleDemoLogin} disabled={loading}>
            🎮 Демо-доступ
          </button>

          <p className="auth-switch">
            Нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
          </p>

          <Link to="/" className="back-link">← Вернуться на главную</Link>
        </form>
      </div>
    </div>
  );
};

export default Login;
